<form [formGroup]="formGroup" (ngSubmit)="onSaveClick()">
    <div mat-dialog-title>
      {{(existingDocumentType ? 'document.edit-document-type' : 'document.create-document-type') | translate : {form: oldName} }}
    </div>
    <mat-dialog-content>
        <mat-form-field class="mt-4" appearance="fill">
          <mat-label>{{'document.document-type' | translate}}</mat-label>
          <input
            matInput
            maxlength="50"
            cdkFocusInitial
            type="text"
            formControlName="label"
          />
        </mat-form-field>
          <mat-error *ngIf="fileService.documentTypeError$ | async as errorMsg">
              {{errorMsg}}
          </mat-error>
    </mat-dialog-content>
  
    <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-stroked-button type="button" mat-dialog-close>{{'common.cancel' | translate}}</button>
      <button
        mat-flat-button
        [disabled]="formGroup.invalid || (fileService.isSavingDocumentTypes$ | async)"
        color="primary"
        type="submit"
      >
        {{'common.save' | translate}}
      </button>
    </mat-dialog-actions>
  </form>
  